
import { Mixins, Component, Watch } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import api from '@/api/poster';
import {
  Input,
  Form,
  FormItem,
  Option,
  Select,
  Button,
  Card,
  Row,
  Col,
  Dialog,
  Upload,
  Tooltip,
  Pagination,
  RadioGroup,
  Radio,
  RadioButton,
} from 'element-ui';
import BsMixin from '@/views/Home/mixins/bsMixin';
import BScroll from 'better-scroll';
import { IBTNCONF } from '@/types/base.d';
import pageMixin from '../../../mixins/pageMixin';

  @Component({
    components: {
      Input,
      Form,
      FormItem,
      Option,
      Select,
      Button,
      Card,
      Row,
      Col,
      Dialog,
      Upload,
      Draggable,
      Tooltip,
      Pagination,
      RadioGroup,
      Radio,
      RadioButton,
    },
  })

export default class poster extends Mixins(BsMixin, pageMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '创建海报模板',
    name: '/set/poster:add',
    icon: 'plus',
    callback: this.handleAddCon,
    log: {
      name: '机构管理 - 新增',
      component: '/set/poster/index',
    },
  }];

  private bs?: BScroll;

  public $refs!:{
    content: Element,
    wrapper: Element,
    posterForm: Form,
  }

  private searchType: number = 0;

  private sortDisable: boolean = true;

  private sortloading: boolean = false;

  private addDialogVisible: boolean = false;

  private fileListModule: any = [];

  private fileListMakeModule: any = [];

  private posterLoading: boolean = false;

  private posterList: any = [];

  private posterForm: any ={
    title: '',
    functionName: '',
    demo: '',
    template: '',
    posterType: '0'
  }

  private posterRules: any = {
    posterType: [
      { required: true, message: '请选则海报类型', triggle: 'change' },
    ],
    title: [
      { required: true, message: '请输入演示模板标题！', triggle: 'blur' },
    ],
    functionName: [
      { required: true, message: '请输入制作模板标题!', triggle: 'blur' },
    ],
    demo: [
      {
        required: true,
        message: '请选择演示模板图片！',
        type: 'object',
        triggle: 'blur',
      },
    ],
    template: [
      {
        required: true,
        message: '请选择制作模板图片！',
        triggle: 'blur',
        type: 'object',
      },
    ],
  }

  mounted() {
    this.page.pageSize = 8;
    this.pageSizes = [8];
  }

  getPosterData(refresh = false) {
    this.posterLoading = true;
    if (refresh) {
      this.posterList = [];
      this.page.pageSize = 8;
      // this.page.pageNo = 1;
    }
    api.getPosterList({ pageSize: this.page.pageSize, pageNo: this.page.pageNo })
      .then((res: any) => {
        this.total = res.totalElements;
        this.posterList = res.content.filter(item => item.type === this.searchType);
        setTimeout(() => {
          this.posterLoading = false;
        }, 300);
      });
  }

  // 计算上传图片框内是否有图片，有图片的话只显示一个图片
  get isShowModule() {
    if (this.fileListModule.length !== 0) return true;
    return false;
  }

  get isShowMakeModule() {
    if (this.fileListMakeModule.length !== 0) return true;
    return false;
  }

  handleAddCon() {
    this.addDialogVisible = true;
  }

  handleIconBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListModule = [{ url: e.target.result }];
    };
    this.posterForm.demo = file;
    return false;
  }

  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListMakeModule = [{ url: e.target.result }];
    };
    this.posterForm.template = file;
    return false;
  }

  handleBeforeRemove(file: any) {
    if (file.status === 'success') {
      this.fileListMakeModule = [];
      this.posterForm.template = '';
    }
  }

  handleIconBeforeRemove(file: any) {
    if (file.status === 'success') {
      this.fileListModule = [];
      this.posterForm.demo = '';
    }
  }

  // 上传海报
  uploadPoster() {
    this.$refs.posterForm.validate((valid: any) => {
      if (valid) {
        const data = new FormData();
        data.set('title', this.posterForm.title);
        data.set('functionName', this.posterForm.functionName);
        data.set('demo', this.posterForm.demo);
        data.set('template', this.posterForm.template);
        data.set('type', this.posterForm.posterType)
        api.upLoadPoster(data).then((res: any) => {
          this.addDialogVisible = false;
          this.getPosterData(true);
          this.resetForm();
        });
      }
    });
  }

  // 删除海报
  removePoster(id: string) {
    this.confirm('你确定要删除该海报吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removePoster(id).then((res) => {
        this.getPosterData(true);
        close();
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '课程章节 - 删除 - 取消',
      component: 'course/chapter',
    }));
  }

  resetForm() {
    this.$refs.posterForm.resetFields();
    this.fileListModule = [];
    this.fileListMakeModule = [];
  }

  // 拖拽事件
  handleDraggable() {
    this.sortDisable = false;
  }

  // 保存排序
  handleSaveSort() {
    this.sortloading = true;
    const posterList: any = this.posterList && this.posterList.map((em: any, index: number) => ({
      id: em.id,
      templateSort: 8 * (this.page.pageNo - 1) + index,
    }));
    api.sortPoster(posterList).then((res: any) => {
      this.sortDisable = true;
      this.sortloading = false;
    });
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.sortDisable = true;
    this.getPosterData(true);
  }

  @Watch('searchType', { immediate: false })
  handleSearchChange() {
    this.getPosterData(true)
  }
}
